import { Component, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'particle-snippet',
  templateUrl: './snippet.component.html',
  styleUrls: ['./snippet.component.scss']
})
export class SnippetComponent implements OnInit {
  showFlowchart: boolean;
  constructor() {
    this.showFlowchart = true;
  }

  ngOnInit() {
    this.loadScripts();
  }

  loadScripts() {
    const node = document.createElement('script');
    node.src = 'https://paperform.co/__embed';
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
    const node2 = document.createElement('div');
    node2.setAttribute('id', 'paperform-co-snippet');
    document.getElementsByTagName('head')[0].appendChild(node2);
  }

  onRestartDac6Flowchart()
  {
    this.showFlowchart = false;
    setTimeout(() => {
      this.loadScripts();
      this.showFlowchart = true;
    }, 2000);
  }
}
